module.exports = __webpack_public_path__ + "site/img/61.170cc404.jpg";